import {useContext} from 'react';
import {IllustratedMessage} from '@ui/images/illustrated-message';
import {ErrorIcon} from '@ui/icons/material/Error';
import {Trans} from '@ui/i18n/trans';
import {Button} from '@ui/buttons/button';
import {DialogContext} from '@ui/overlays/dialog/dialog-context';
import {StackScreenContext} from '@ui/overlays/stack-navigator/stack-screen-context';
import {stackNavigatorState} from '@ui/overlays/stack-navigator/stack-navigator-store';
import {Link} from 'react-router-dom';

export function PageErrorMessage() {
  const dialogContext = useContext(DialogContext);
  const stackScreen = useContext(StackScreenContext);
  const isCurrentStackScreenDialog =
    !!stackScreen && dialogContext?.formId === `${stackScreen.key}-form`;
  const isInStackedDialog =
    dialogContext?.type === 'stacked' && !isCurrentStackScreenDialog;
  const isInStackedNavigation = !!stackScreen && !isInStackedDialog;

  return (
    <IllustratedMessage
      className="mt-40"
      image={
        <div>
          <ErrorIcon size="xl" />
        </div>
      }
      imageHeight="h-auto"
      title={<Trans message="There was an issue loading this page" />}
      description={<Trans message="Please try again later" />}
      action={
        isInStackedDialog ? (
          <Button variant="flat" color="primary" onClick={() => dialogContext?.close()}>
            <Trans message="Close" />
          </Button>
        ) : isInStackedNavigation ? (
          <Button
            variant="flat"
            color="primary"
            onClick={() => stackNavigatorState.dismissAll()}
          >
            <Trans message="Close" />
          </Button>
        ) : (
          <Button variant="flat" color="primary" elementType={Link} to="/">
            <Trans message="Go to homepage" />
          </Button>
        )
      }
    />
  );
}
